import { Routes } from '@angular/router';
import { Page404Component } from './shared/pages/page404/page404.component';
import { Page403Component } from './shared/pages/page403/page403.component';
import { Page500Component } from './shared/pages/page500/page500.component';
import { Page503Component } from './shared/pages/page503/page503.component';
import { HouseAccountGuard } from './core/guards/house-account.guard';
import { AdminGuard } from './core/guards/admin.guard';
import { SuperAdminGuard } from './core/guards/super-admin.guard';
import { RoleGuard } from './core/guards/role.guard';

export const routes: Routes = [
	{
		path: 'auth',
		loadComponent: () => import('../app/modules/auth/auth.component'),
		children: [
			{
				path: 'login',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () =>
					import('./modules/auth/pages/login/login.component'),
			},
			{
				path: 'forgot-password',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () =>
					import(
						'./modules/auth/pages/forgot-password/forgot-password.component'
					),
			},
			{
				path: 'eliminacion-de-datos',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () =>
					import(
						'./modules/auth/pages/delete-user-steps/delete-user-steps.component'
					),
			},
			{
				path: 'forgot-password/:t',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () =>
					import(
						'./modules/auth/pages/forgot-password/forgot-password.component'
					),
			},

			{ path: '', redirectTo: 'login', pathMatch: 'full' },
		],
	},
	{
		path: 'dashboard',
		loadComponent: () => import('./modules/dashboard/dashboard.component'),
		canActivate: [HouseAccountGuard],
		children: [
			{
				path: 'clients',
				title: 'Package Hub',
				canActivate: [RoleGuard],
				data: {
					translate: 'navbar.clients',
					roles: [2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
				loadComponent: () =>
					import('./modules/dashboard/pages/clients/clients.component'),
			},
			{
				path: 'clients-details',
				title: 'Package Hub',
				canActivate: [RoleGuard],
				data: {
					translate: 'navbar.clients',
					roles: [2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
				loadComponent: () =>
					import('./modules/dashboard/pages/client-detail/client-detail.component'),
			},
			{
				path: 'clients/:email',
				title: 'Package Hub',
				canActivate: [RoleGuard],
				data: {
					translate: 'navbar.clients',
					roles: [2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
				loadComponent: () =>
					import('./modules/dashboard/pages/clients/clients.component'),
			},
			{
				path: 'worker',
				title: 'Package Hub',
				canActivate: [RoleGuard],
				data: {
					translate: 'navbar.clients',
					roles: [2, 6], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
				loadComponent: () =>
					import('./modules/dashboard/pages/worker/worker.component'),
			},
			{
				path: 'overview',
				title: 'Package Hub',
				canActivate: [RoleGuard],
				data: {
					translate: 'navbar.clients',
					roles: [2, 6], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
				loadComponent: () =>
					import('./modules/dashboard/pages/overview/overview.component'),
			},
			{
				path: 'add-new-locker',
				title: 'Package Hub',
				canActivate: [RoleGuard],
				data: {
					translate: 'LOCKERS',
					roles: [1], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
				loadComponent: () =>
					import('./modules/dashboard/pages/add-new-locker/add-new-locker.component'),
			},
			{
				path: 'locker',
				title: 'Package Hub',
				canActivate: [RoleGuard],
				data: {
					translate: 'LOCKERS',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
				loadComponent: () =>
					import('./modules/dashboard/pages/locker/locker.component'),
			},
			{
				path: 'locker-detail/:id_locker',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/locker-detail/locker-detail.component'
					),
				canActivate: [RoleGuard],
				data: {
					translate: 'LOCKERS DETAIL',
					roles: [1, 2, 6, 7], // SUPER USUARIO(1) y  Solo Admin (2) y House account(6)
				},
			},
			{
				path: 'locker-preferences/:id_locker',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/locker-preferences/locker-preferences.component'
					),
				canActivate: [RoleGuard],
				data: {
					translate: 'LOCKERS DETAIL',
					roles: [1], // Solo Admin (2) y House account(6)
				},
			},
			{
				path: 'create-model',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/add-new-model/add-new-model.component'
					),
				canActivate: [RoleGuard],
				data: {
					translate: 'LOCKERS DETAIL',
					roles: [1], // Solo Admin (2) y House account(6)
				},
			},
			{
				path: 'create-compartment',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/add-new-compartment/add-new-compartment.component'
					),
				canActivate: [RoleGuard],
				data: {
					translate: 'LOCKERS DETAIL',
					roles: [1], // Solo Admin (2) y House account(6)
				},
			},
			{
				path: 'order-detail/:id',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/orders-detail/orders-detail.component'
					),
				canActivate: [RoleGuard],
				data: {
					translate: 'Orders DETAIL',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'users',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/users/users.component'),
				canActivate: [RoleGuard],
				data: {
					translate: 'Users',
					roles: [1, 2, 6, 7], // Solo Admin (2)
				},
			},
			{
				path: 'profile',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/profile/profile.component'),
				canActivate: [RoleGuard],
				data: {
					translate: 'profile',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'version',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/version/version.component'),
				canActivate: [RoleGuard],
				data: {
					translate: 'version',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'orders',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/orders/orders.component'),
				canActivate: [RoleGuard],
				data: {
					translate: 'orders',
					roles: [2, 6, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'carrier',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/transporter/transporter.component'),
				canActivate: [RoleGuard],
				data: {
					translate: 'transporter',
					roles: [2, 6], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'carrier/detail/:id_transportist',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/transporter-detail/transporter-detail.component'
					),
				canActivate: [RoleGuard],
				data: {
					translate: 'transporter',
					roles: [2, 6], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'orders/:trackingNumber',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/orders/orders.component'),
				canActivate: [RoleGuard],
				data: {
					translate: 'orders',
					roles: [2, 6, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'company',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/company/company.component'),
				canActivate: [RoleGuard],
				data: {
					translate: 'company',
					roles: [1, 2, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},

			{
				path: 'company_detail/:id_company',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/company-detail/company-detail.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2, 7 ], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'historial-subscription/:id_company',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/company-detail/pages/historial-subscription/historial-subscription.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2, 6], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'configuration-property/:id_company',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/company-detail/pages/configuration-property/configuration-property.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'package-property/:id_company',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/company-detail/pages/package-property/package-property.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'residents-property/:id_company',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/company-detail/pages/residents-property/residents-property.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'units-property/:id_company',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/company-detail/pages/units-property/units-property.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: ':id_company/property_detail/:id_property',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/property-detail/property-detail.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'add_property/:id_company',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/add-property/add-property.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'add_company',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/add-company/add-company.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2 ,7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: ':id_company/add_service/:id_property',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/add-service/add-service.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden accederds
				data: {
					translate: 'company',
					roles: [1, 2, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'property',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/company-detail/company-detail.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [2,6,7], // Admin (2)
				},
			},
			{
				path: 'notifications-details',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/notification-details/notification-details.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'worker-detail/:worker',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/worker-detail/worker-detail.component'
					),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'company',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1) y Admin (2)
				},
			},
			{
				path: 'units',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/units/units.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'unit-detail/:id',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/unit-detail/unit-detail.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'subscriptions',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/subscriptions/subscriptions.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1, 2, 6], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'validate-package/:id_package',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/validate-package/validate-package.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'campaings',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/campaings/campaings.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'success',
				title: 'Success Pay',
				loadComponent: () =>
					import('./modules/dashboard/pages/success-pay/success-pay.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'cancel',
				title: 'Cancel Pay',
				loadComponent: () =>
					import('./modules/dashboard/pages/cancel-pay/cancel-pay.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1, 2, 6, 7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'tickets',
				title: 'Tickets',
				loadComponent: () =>
					import('./modules/dashboard/pages/tickets/tickets.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'cameras',
				title: 'Cameras',
				loadComponent: () =>
					import('./modules/dashboard/pages/cameras-page/cameras-page.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1,2,6,7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: ':id_ticket/detail-tickets',
				title: 'Tickets',
				loadComponent: () =>
					import('./modules/dashboard/pages/ticket-detail/ticket-detail.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
			{
				path: 'services',
				title: 'Services',
				loadComponent: () =>
					import('./modules/dashboard/pages/services/services.component'),
				canActivate: [RoleGuard], // Solo los Super Administradores y administradores pueden acceder
				data: {
					translate: 'property',
					roles: [1,2,6,7], // Solo SuperAdmin (1), Admin (2) y House account(6)
				},
			},
		],
	},
	{
		path: '403',
		component: Page403Component,
	},
	{
		path: '404',
		component: Page404Component,
	},
	{
		path: '500',
		component: Page500Component,
	},
	{
		path: '503',
		component: Page503Component,
	},
	{ path: '', redirectTo: '/auth', pathMatch: 'full' },
	{ path: '**', redirectTo: '/404', pathMatch: 'full' },
];
